/*
 * Expense Inventory detail GraphQL specification
 * @module src/graphql/getExpenseInventoryDetails
 */
/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

/** Expense Inventory single-case detail GraphQL API query */
export const GET_EXPENSE_INVENTORY_DETAILS = gql`
  query getExpenseInventoryDetails($id: String, $externalId: String) {
    getExpenseInventoryDetails(id: $id, externalId: $externalId) {
      id
      caseExternalId
      caseNumber
      status
      accountId
      accountDisplay
      salesRepId
      salesRepName
      shipTo
      shipToDisplay
      branchId
      branch
      businessUnit
      division
      subInventoryCode
      region
      territory
      createdDate
      createdBy
      updatedDate
      updatedBy
      submittedDate
      orderType
      failureReason
      erpOrderNumber
      doctorName
      facilityNameOrLocation
      usageDate
      usedInPatientCare
      marketingCollaboration
      writeOffType
      system
      totalCost
      version
      caseVersion
      lineItems {
        sfid
        externalId
        productId
        cost
        part
        productNumber
        productDescription
        status
        lotSerial
        quantity
        actualQuantity
        sourceLocation
        partAddedFrom
        subInventoryCode
        availableQuantity
        isValidLotSerialCombination
        expirationDate
        action
        baseorCapital
      }
      attachments {
        id
        name
        imageurl
        attachmentType
        showOnUsageSheet
        createdBy
        createdAt
      }
    }
  }
`;
